module.exports = __webpack_public_path__ + "media/post-listing-block-6-image-step2.eabb5fdb.png";